import { XMarkIcon } from "@heroicons/react/24/outline";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export default function AlertModal({ open, onClose, title = "Atención", messages = [], onConfirm, confirmLabel = "Confirmar" }) {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50"
            onClick={(e) => { e.stopPropagation(); onClose(); }}
        >
            <div
                className="relative w-full max-w-md mx-4 rounded-xl bg-white p-6 text-left shadow-xl dark:bg-gray-900"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute right-3 top-3 rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                >
                    <XMarkIcon className="h-5 w-5" />
                </button>

                <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40">
                        <ExclamationTriangleIcon className="h-5 w-5 text-amber-600 dark:text-amber-400" />
                    </div>
                    <div className="min-w-0">
                        <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                            {title}
                        </h3>
                        <ul className="mt-2 space-y-1">
                            {messages.map((msg, i) => (
                                <li key={i} className="text-sm text-gray-600 dark:text-gray-400">
                                    • {msg}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-5 flex justify-end gap-2">
                    {onConfirm && (
                        <button
                            type="button"
                            onClick={onClose}
                            className="rounded-xl px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-gray-300 dark:text-gray-200 dark:ring-gray-600"
                        >
                            Cancelar
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={onConfirm || onClose}
                        className="rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm"
                    >
                        {onConfirm ? confirmLabel : "Entendido"}
                    </button>
                </div>
            </div>
        </div>
    );
}
